import SignIn from '../../structure/SignIn';
import SignOut from '../../structure/SignOut';
import AuthCallback from '../../structure/AuthCallback';
import SetupRequired from '../../structure/SetupRequired';
import Unauthorized from '../../structure/Unauthorized';
import LoginFailed from '../../structure/LoginFailed';
import HttpError from '../../structure/HttpError';
import PageNotFound from '../../structure/PageNotFound';

import homeRoutes from './homeRoutes';
import releaseRoutes from './releaseRoutes';
import docRoutes from './docRoutes';

import settingsRoutes from './settings-routes';

//-- private is a reserved word, so use secured instead

const routes = [
	...[
		{
			id: 'sign-in',
			name: 'sign-in',
			paths: ['/sign-in', '/signin', '/log-in', '/login'],
			exact: true,
			component: SignIn,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Sign In',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: true,
				signOut: false,
				authCallback: false,
				setupRequired: false,
				unauthorized: false,
				loginFailed: false,
				httpError: false,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		},
		{
			id: 'sign-out',
			name: 'sign-out',
			paths: ['/sign-out', '/signout', '/log-out', '/logout'],
			exact: true,
			component: SignOut,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				icon: null,
				cornerIcon: null,
				module: 'sign-out',
				level: 1,
				children: null,
				signIn: false,
				signOut: true,
				authCallback: false,
				setupRequired: false,
				unauthorized: false,
				loginFailed: false,
				httpError: false,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		},
		{
			id: 'auth-callback',
			name: 'auth-callback',
			paths: ['/auth-callback'],
			exact: true,
			component: AuthCallback,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Auth Callback',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: false,
				signOut: false,
				authCallback: false,
				setupRequired: false,
				unauthorized: false,
				loginFailed: false,
				httpError: false,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		}
	],
	...homeRoutes,
	...releaseRoutes,
	...docRoutes,
	...settingsRoutes,
	...[
		{
			id: 'setup-required',
			name: 'setup-required',
			paths: ['/setup-required'],
			exact: false,
			component: SetupRequired,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Setup required',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: false,
				signOut: false,
				authCallback: false,
				setupRequired: true,
				unauthorized: false,
				loginFailed: false,
				httpError: false,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		},
		{
			id: 'unauthorized',
			name: 'unauthorized',
			paths: ['/unauthorized'],
			exact: false,
			component: Unauthorized,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Unauthorized',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: false,
				signOut: false,
				authCallback: false,
				setupRequired: false,
				unauthorized: true,
				loginFailed: false,
				httpError: false,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		},
		{
			id: 'login-failed',
			name: 'login-failed',
			paths: ['/login-failed'],
			exact: false,
			component: LoginFailed,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Login failed',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: false,
				signOut: false,
				authCallback: false,
				setupRequired: false,
				unauthorized: false,
				loginFailed: true,
				httpError: false,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		},
		{
			id: 'http-error',
			name: 'http-error',
			paths: ['/http-error'],
			exact: false,
			component: HttpError,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Something broke',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: false,
				signOut: false,
				authCallback: false,
				setupRequired: false,
				unauthorized: false,
				loginFailed: false,
				httpError: true,
				pageNotFound: false,
				home: false,
				content: false,
				settings: false
			}
		},
		{
			//-- This must be last in the modules list b/c exact is false and will match before desired routes
			id: 'page-not-found',
			name: 'page-not-found',
			paths: ['/page-not-found', ''],
			exact: false,
			component: PageNotFound,
			meta: {
				enabled: true,
				secured: false,
				roles: [],
				showInNav: false,
				showBreadcrumb: true,
				linkText: 'Page Not Found',
				icon: null,
				cornerIcon: null,
				level: 1,
				children: null,
				signIn: false,
				signOut: false,
				authCallback: false,
				setupRequired: false,
				unauthorized: false,
				loginFailed: false,
				httpError: false,
				pageNotFound: true,
				home: false,
				content: false,
				settings: false
			}
		}
	]
];

export default routes;
